import PropTypes from 'prop-types';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'src/auth/context';
import { paths } from 'src/routes/paths';
import { LoadingScreen } from 'src/components/loading-screen';

export default function AdminGuestGuard({ children }) {
  const { isAdminAuthenticated, loading, admin } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    // Only redirect when an ADMIN is already authenticated.
    // Do not redirect because of a client/wallet session.
    if (isAdminAuthenticated && admin?.role === 'admin') {
      navigate(paths.admin.dashboard, { replace: true });
    }
  }, [isAdminAuthenticated, loading, admin, navigate]);

  if (loading) return <LoadingScreen />;

  // If already admin, the effect redirects to dashboard.
  if (isAdminAuthenticated && admin?.role === 'admin') {
    return null;
  }

  // Client phone/wallet sessions are allowed to see the admin login page.
  return children;
}

AdminGuestGuard.propTypes = {
  children: PropTypes.node,
};
